export default "__VITE_ASSET__DHCV5Oea__"